/** @jsx jsx */
import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Box, Container, Grid, jsx, Text } from 'theme-ui'
import MerchCardSimple from '~/components/Merch/Card/Simple'
import PackCardSimple from '~/components/Pack/Card/Simple'

const ProductListLargeSectionCard = ({ listing, type }) => {
  if (type === 'ContentfulMerch') {
    return <MerchCardSimple merch={listing} showPrice={false} />
  }

  if (type === 'ContentfulPack') {
    return <PackCardSimple pack={listing} showPrice={false} />
  }

  return <Fragment />
}

const ProductListLargeSection = ({
  collapseMarginTop,
  title,
  products,
  cta,
}) => {
  return (
    <Box
      pt={!collapseMarginTop && [3, 4, null, 6]}
      pb={[4, 5, null, 7]}
      bg="backgroundLight"
    >
      <Container>
        {title && (
          <Box mb={3}>
            <Text as="h2" variant="title2">
              {title}
            </Text>
          </Box>
        )}
        <Grid columns={[1, 3]}>
          {products.map((listing, index) => {
            return (
              <ProductListLargeSectionCard
                key={index}
                listing={listing}
                type={listing.__typename}
              />
            )
          })}
        </Grid>
        <Box mt={[3, 4]} sx={{ textAlign: 'center' }}>
          {cta}
        </Box>
      </Container>
    </Box>
  )
}

ProductListLargeSection.propTypes = {
  title: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  cta: PropTypes.shape({}),
}

export default ProductListLargeSection
